import moment from 'moment'
export const getDay = (text, withDay = false) => {
  let currentDate = moment(text)
  let date
  withDay
    ? (date = currentDate.format('DD/MM/YYYY'))
    : (date = currentDate.format('MM/YYYY'))
  return date
}
